import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignIn } from '@fortawesome/pro-light-svg-icons/faSignIn';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LinkButton from '../common/Buttons/LinkButton';
import { hideModal } from '../../redux/actions/GlobalModalActions';
import { showSuccess } from '../../redux/actions/GlobalToastActions';
import { idUser } from '../../redux/reducers/AuthReducer';
import { switchContext } from '../../redux/actions/AuthActions';
import { Routes as configRouter } from '../../config/Routes';
import Input from '../common/Formik/Input';

class LoginSwitchContext extends Component {
  state = {
    data: '',
    isSubmitting: false,
  };

  handleDataChange = (e) => {
    const {
      target: { value },
    } = e;
    this.setState({ data: value });
  };

  isValid = () => {
    const { data } = this.state;
    return data.trim().length !== 0;
  };

  handleLoginAccount = () => {
    const { data } = this.state;
    const { account, mfaEnabled, showSuccess, hideModal, switchContext, t, history } = this.props;
    const loginData = mfaEnabled ? { mfaCode: data } : { password: data };
    this.setState({ isSubmitting: true });
    switchContext({ idMerchant: account.key, password: loginData }).then((data) => {
      if (data.error !== true) {
        hideModal();
        showSuccess(t('successSwitchContext'));
        history.push(configRouter.HOME);
      }
      this.setState({ isSubmitting: false });
    });
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 13 && this.isValid()) this.handleLoginAccount();
  };

  render() {
    const { onCancel, account, color, mfaEnabled, t } = this.props;
    const { data, isSubmitting } = this.state;
    return (
      <div className="settings-list editing">
        <h1>
          <div className="letter-wrapper-login">
            <span
              className="letter"
              style={{
                textTransform: 'uppercase',
                backgroundColor: color,
              }}
            >
              {account && account.value ? account.value[0] : 'M'}
            </span>{' '}
            &nbsp; {t('labelLoginTo', { name: account && account.value ? account.value : '' })}
          </div>
          <LinkButton className="edit-button" onClick={onCancel}>
            {t('labelGoBack')}
          </LinkButton>
        </h1>
        <div className="settings-list__item">
          <span className="label">{mfaEnabled ? t('labelMfaCode') : t('labelPassword')}</span>
          <span className="input">
            {mfaEnabled ? (
              <input name="switchMfaCode" type="text" className="form-control" autoComplete="off" value={data} onChange={this.handleDataChange} onKeyDown={this.handleKeyDown} />
            ) : (
              <Input withIcon canToggleIcon type="password" name="switchPassword" autoComplete="off" value={data} handleChange={(data) => this.setState({ data })} />
            )}
          </span>
        </div>
        <div className="text-right">
          <button type="submit" className="btn btn-link btn-switch" disabled={!this.isValid() || isSubmitting} onClick={this.handleLoginAccount}>
            <FontAwesomeIcon icon={!isSubmitting ? faSignIn : 'spinner'} className="mr-2" />
            {t('loginName')}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    idUser: idUser(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      hideModal,
      showSuccess,
      switchContext,
    },
    dispatch
  );

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(LoginSwitchContext);
